import { Component, Inject, OnDestroy } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SubSink } from 'subsink';
import {
  CreateUserAlliedBody,
  UserAlliedService,
} from 'src/app/services/user-allied.service';

@Component({
  selector: 'app-create-user-allied',
  templateUrl: './create-user-allied.component.html',
  styleUrls: ['./create-user-allied.component.scss'],
})
export class CreateUserAlliedComponent implements OnDestroy {
  private subs = new SubSink();
  public hideRequiredControl = new FormControl(true);
  public isCreating: boolean = false;

  public userAlliedForm: FormGroup = this.fb.group({
    hideRequired: this.hideRequiredControl,
    email: ['', [Validators.required, Validators.email]],
    role: ['Standard', [Validators.required]],
  });

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<CreateUserAlliedComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { idAllied: string },
    private userAlliedService: UserAlliedService,
    private _snackBar: MatSnackBar,
  ) {}

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private createUser(body: CreateUserAlliedBody): void {
    this.subs.sink = this.userAlliedService.createUserAllied(body).subscribe({
      next: () => {
        this.isCreating = false;
        this.dialogRef.close(true);
        this._snackBar.open('Usuario creado con éxito', 'cerrar', {
          duration: 3000,
          horizontalPosition: 'right',
          verticalPosition: 'top',
        });
      },
      error: (error) => {
        this.isCreating = false;

        const backendMessage =
          error?.error?.message ||
          error?.error?.errors?.[0]?.message ||
          'Ups! error al crear el usuario';

        this._snackBar.open(backendMessage, 'cerrar', {
          duration: 4000,
          horizontalPosition: 'right',
          verticalPosition: 'top',
          panelClass: 'my-snackbar-error',
        });
      },
    });
  }

  public sendData(form: FormGroup): void {
    if (form.invalid) {
      this.markFormError(form);
      return;
    }

    this.isCreating = true;

    const body: CreateUserAlliedBody = {
      id_allied: this.data.idAllied,
      email: this.userAlliedForm.value.email,
      role: this.userAlliedForm.value.role,
    };

    this.createUser(body);
  }

  private markFormError(form: FormGroup): void {
    Object.values(form.controls).forEach((control) => {
      control.markAllAsTouched();
    });
  }

  public closeModal(): void {
    if (this.isCreating) {
      return;
    }

    this.dialogRef.close(false);
  }
}
